import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

function NewsDetails() {
  const location = useLocation();
  const { content, coverUrl, title, description, author, createdAt } = location.state?.article || {};

  // Scroll to top when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Fallback if no data is available
  if (!location.state?.article) {
    return (
      <div className="content-inner container-fluid pb-0" id="page_layout">
        <div className="row row--grid">
          <div className="col-12 col-xl-10 offset-xl-1">
            <div className="article">
              <div className="article__content">
                <h1>Article Not Found</h1>
                <p>The article you're looking for is not available.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="content-inner container-fluid pb-0" id="page_layout">
        <div className="row row--grid">
          <div className="col-12">
            <ul className="breadcrumb">
              <li className="breadcrumb__item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb__item ">
                <Link to="/news">News</Link>
              </li>
              <li className="breadcrumb__item breadcrumb__item--active">
                News Details
              </li>
            </ul>
          </div>
          <div className="col-12">
            <div className="main__title main__title--page">
              <h2 className="card-title text-capitalize mt-3">{title || "News Details"}</h2>
            </div>
          </div>
        </div>
        <div className="row row--grid">
          <div className="col-12 col-xl-10 offset-xl-1">
            <div className="article">
              {/* Article content */}
              <div className="article__content">
                {/* Use dynamic cover image */}
                {coverUrl && (
                  <img
                    src={coverUrl}
                    alt="Article cover"
                    className="article__cover"
                  />
                )}

                <div className="article__meta">
                  {/* <a className="article__category">Documentary</a> */}
                  <span className="article__date">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20ZM14.09814,9.63379,13,10.26807V7a1,1,0,0,0-2,0v5a1.00025,1.00025,0,0,0,1.5.86621l2.59814-1.5a1.00016,1.00016,0,1,0-1-1.73242Z" />
                    </svg>{" "}
                    {createdAt ? new Date(createdAt).toLocaleDateString() : new Date().toLocaleDateString()}
                  </span>
                  {author && (
                    <span className="article__author d-flex ">
                      
                     <span> By {author}</span>
                    </span>
                  )}
                </div>

                {/* Render dynamic HTML content */}
                {description && (
                  <p className="article__description">{description}</p>
                )}
                {content ? (
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                ) : (
                  <div>
                    <h1>{title || "Default Title"}</h1>
                    <p>No content available for this article.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewsDetails;
